import * as React from "react";
import { forwardRef } from "react";
const SvgMinus = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M6.138 13.275a1.1 1.1 0 0 1-.809-.33A1.1 1.1 0 0 1 5 12.138c0-.319.11-.588.33-.808.219-.22.488-.329.808-.329h12.131c.32 0 .589.11.808.33.22.219.33.488.33.807 0 .32-.11.59-.33.809a1.1 1.1 0 0 1-.808.329H6.138Z" }));
const ForwardRef = forwardRef(SvgMinus);
export default ForwardRef;
